import z from "zod";

const appSchema = z.object({
  client_id: z.string(),
  client_secret: z.string(),
  id: z.string(),
  name: z.string(),
  redirect_uri: z.string(),
  vapid_key: z.string(),
  website: z.string(),
});

type App = z.infer<typeof appSchema>;

export { appSchema, type App };
